/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef, useCallback } from "react";

import ProductService from "../../services/product.service";
import requestAndErrorHandler from "../../services/responseAndErrorHandler";
import { toast } from "react-toastify";
import _ from "lodash";
import VendorService from "../../services/vendor.services";
import TokenService from "../../services/token.service";
import LayoutContainer from "../../FUSComponents/LayoutContainer/LayoutContainer";
import { FUSButton } from "../../FUSComponents/FUSElements/FUSButton/FUSButton";
import FUSIcon from "../../FUSComponents/FUSIcon/FUSIcon";
import FUSModal from "../../FUSComponents/FUSModal/FUSModal";
import AddProductItem from "../Products/components/AddProductItem";
import { ROLES } from "../../constants/constants";
import { keyFeaturesValidation } from "../../validation/validation";

const Products = () => {
  const [allVendorItems, setAllVendorItem] = useState([]);
  const [lobOptions, setLobOptions] = useState([]); // state to store unique lob data
  const [searchQuery, setSearchQuery] = useState(""); // state to handle seach query
  const token = TokenService.getUser();
  const vendorID = token?.vendor?.id;
  const [show, setShow] = useState({
    state: false,
    type: null,
  });
  const [lobData, setLobData] = useState([]); // state to store response data , used for filtering data
  const [flag, setFlag] = useState(true);
  const [filter, selectFilter] = useState(" ");
  const [categories, setCategories] = useState([]);
  const [categoryId, setCategoryId] = useState(null);
  const [lob_ID, setLob_ID] = useState(null);
  const [isSubmitShow, setIsSubmitShow] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [action, setAction] = useState("Add Product");
  const [custom, setCustom] = useState(false);
  const [vendorActionTypeToggle, setVendorActionTypeToggle] = useState("");
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [allProducts, setAllProducts] = useState([]);
  const [id, setId] = useState(null);
  const vendorApporval = token?.vendorApproved?.is_approved;
  const [showModal, setShowModal] = useState({
    state: false,
    type: "",
  });
  const [isReload, setIsReload] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    fetchAllKeyFeatures();
  }, [flag, lob_ID, categoryId, lobOptions, toggle, isReload]);

  const fetchAllKeyFeatures = async (params) => {
    try {
      const result = await ProductService.getAllProductKeyFeatures({
        flag: flag,
        lob_id: lob_ID,
        category_id: categoryId,
      });

      if (result.data.errorCode === 0) {
        setLobData(result?.data?.data);
        const sortItems = _.orderBy(result?.data?.data, "id", "asc");
        setAllVendorItem(sortItems);

        setIsReload(true);
      } else {
        setAllVendorItem([]);
      }
    } catch (error) {
      requestAndErrorHandler.errorHandler(error);
    }
  };
  const filterDataByLob = (value) => {
    if (value === "All") {
      setCategoryId(null);
      setLob_ID(value);
      setAllVendorItem(lobData);
    } else {
      setCategoryId(null);
      setLob_ID(value);
      const lobID = Number(value);
      const filterLobData = lobData.filter((item) => item.lob_id === lobID);
      setAllVendorItem(filterLobData);
    }
  };

  const handleSearch = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    const filtered = lobData.filter((item) => {
      const productName = item.product_name || "";
      const LOBName = item.lob_name || "";
      const CategoryName = item.category_name || "";
      const sku = item.sku || "";
      return (
        productName.toLowerCase().includes(query.toLowerCase()) ||
        LOBName.toLowerCase().includes(query.toLowerCase()) ||
        CategoryName.toLowerCase().includes(query.toLowerCase()) ||
        sku.toLowerCase().includes(query.toLowerCase())
      );
    });

    setAllVendorItem(filtered);
  };

  const handleCloseModal = () => {
    setShow({
      type: null,
      state: false,
    });
  };

  const filterDataByCategory = (value) => {
    setCategoryId(value);
  };

  const handleFilterChange = (e) => {
    setFlag(e.target.value);
  };

  const handleDeleteKeyFeatures = useCallback(async (obj) => {
    try {
      const result = await ProductService.deleteKeyFeatures({
        item_id: obj?.id,
      });
      if (result?.data?.errorCode === 0) {
        setToggle(!toggle);
        fetchAllKeyFeatures();
        const successToast = toast.success(`${result?.data?.message}`, {
          position: "bottom-left",
          autoClose: false,
        });
        setTimeout(() => {
          toast.dismiss(successToast);
        }, 2000);
      }
    } catch (error) {
      requestAndErrorHandler.errorHandler(error);
    }
  });
  const activateKeyFeatures = async (obj) => {
    try {
      const result = await ProductService.activateKeyFeatures({
        item_id: obj?.id,
      });
      if (result?.data?.errorCode === 0) {
        fetchAllKeyFeatures();
        const successToast = toast.success(`${result?.data?.message}`, {
          position: "bottom-left",
          autoClose: false,
        });
        setTimeout(() => {
          toast.dismiss(successToast);
        }, 2000);
      }
    } catch (error) {
      requestAndErrorHandler.errorHandler(error);
    }
  };

  const updateItems = async (data) => {
    const validationErrors = {};

    data.forEach((item, index) => {
      const errors = keyFeaturesValidation(item);
      if (!_.isEmpty(errors)) {
        validationErrors[item?.id || index] = errors;
      }
    });

    if (!_.isEmpty(validationErrors)) {
      setErrors(validationErrors);
      return;
    }

    try {
      const result = await ProductService.updateKeyFeatures({
        dataArray: data,
      });
      if (result?.data?.errorCode === 0) {
        setToggle(!toggle);
        setIsSubmitShow(false);
        const successToast = toast.success(`${result?.data?.message}`, {
          position: "bottom-left",
          autoClose: false,
        });
        setTimeout(() => {
          toast.dismiss(successToast);
        }, 2000);
        setCustom(false);
      }
    } catch (error) {
      requestAndErrorHandler.errorHandler(error);
    }
  };

  const submitEdit = async () => {
    const updatedData = allVendorItems.filter((item) => item.is_updated);

    if (updatedData.length > 0) {
      updateItems(updatedData);
    }
  };

  const handleEnterPress = async (data) => {
    updateItems(data);
  };
  const handleEdit = () => {
    if (!vendorApporval) {
      setShowModal((prev) => ({
        ...prev,
        state: true,
        type: "VENDOR_APPROVAL",
      }));
    } else {
      setCustom(true);
      setIsDropdownVisible(false);
    }
  };
  const handleShow = () => {
    if (!vendorApporval) {
      setShowModal((prev) => ({
        ...prev,
        state: true,
        type: "VENDOR_APPROVAL",
      }));
    } else {
      setShowModal((prev) => ({ ...prev, state: true, type: "ADD_PRODUCT" }));
    }
  };
  const handleClose = (val) => {
    setShowModal((prev) => ({ ...prev, state: false }));
    setVendorActionTypeToggle("");
    setIsReload(false);
  };
  const handleActionType = (val) => {
    setAction(val);
  };

  useEffect(() => {
    VendorService.getLobByVendorId({ vendor_id: vendorID })
      .then((res) => {
        if (res?.data?.errorCode === 0) {
          setLobOptions(res?.data?.data);
        }
      })
      .catch((error) => {
        requestAndErrorHandler.errorHandler(error);
      });
  }, []);

  useEffect(() => {
    if (lob_ID != null) {
      VendorService.getCategoryByLOBID({ lob_id: lob_ID })
        .then((res) => {
          if (res?.data?.errorCode === 0) {
            setCategories(res?.data?.data);
          } else {
            setCategories([]);
          }
        })
        .catch((error) => {
          requestAndErrorHandler.errorHandler(error);
        });
    }
  }, [lob_ID]);

  const getAllProductsByCategory = useCallback(
    async (categoryId) => {
      let vendor_id;
      if (token?.role?.role_id === ROLES.PRODUCT_MANANGEMENT) {
        vendor_id = vendorID?.vendor_user_id;
      } else {
        vendor_id = token?.agent?.agent_user_id;
      }
      if (categoryId) {
        try {
          const result = await ProductService.getAllProductsByCategoryId({
            category_id: parseInt(categoryId),
            vendor_id: vendor_id,
          });
          if (result?.data?.errorCode === 0) {
            setAllProducts(result?.data?.data);
          }
        } catch (error) {
          requestAndErrorHandler.errorHandler(error);
        }
      }
    },
    [categoryId]
  );

  return (
    <>
      <LayoutContainer
        title1="Product"
        title2="Product"
        title3="Manage Key Features"
        right={<></>}
      >
        <div className="px-1">
          <div className="border_bottom_style">
            <div className="row justify-content-between">
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-4 ps-0 ms-0">
                    <div className="form-group">
                      <select
                        name="filter"
                        id="filter"
                        className="form-select py-2  text_style"
                        onChange={(e) => filterDataByLob(e.target.value)}
                      >
                        <option value="">Select Lob</option>
                        {lobOptions?.length > 0 &&
                          lobOptions?.map((item) => (
                            <>
                              <option value={item?.lob_id}>{item?.lob}</option>
                            </>
                          ))}
                      </select>
                      {/*  */}
                      <div className="form-group">
                        <select
                          name="filter"
                          id="filter"
                          className="form-select py-2  text_style"
                          onChange={(e) => filterDataByCategory(e.target.value)}
                        >
                          <option value="">Select Category</option>
                          {categories?.length > 0 &&
                            categories?.map((item) => (
                              <>
                                <option
                                  value={item?.category_id}
                                  key={item?.category_id}
                                >
                                  {item?.category_name}
                                </option>
                              </>
                            ))}
                        </select>
                      </div>
                      {/*  */}
                    </div>
                  </div>
                  <div className="col-md-4 ps-0 ms-0">
                    <div className="form-group">
                      <select
                        name="filter"
                        id="filter"
                        className="form-select text_style py-2"
                        onChange={(e) => handleFilterChange(e)}
                      >
                        <option value={"true"}>Activated </option>
                        <option value={"false"}>Deactivated </option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4 ps-0 ms-0">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control text_style py-2"
                        placeholder="Search Here......."
                        value={searchQuery}
                        onChange={handleSearch}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 d-flex gap-3 justify-content-end align-items-end">
                <div>
                  <FUSButton
                    className={"py-2"}
                    buttonType="primary"
                    labelText={"Add Features"}
                    onClick={handleShow}
                  />
                </div>

                {isSubmitShow ? (
                  <div>
                    <FUSButton
                      className={"py-2"}
                      labelText={"Update"}
                      buttonType="primary"
                      onClick={() => submitEdit()}
                    />
                  </div>
                ) : !custom ? (
                  <div>
                    <FUSButton
                      className={"py-2"}
                      labelText={"Edit Features"}
                      buttonType="primary"
                      onClick={handleEdit}
                    />
                  </div>
                ) : (
                  <div>
                    <FUSButton
                      className={"py-2"}
                      labelText={"Cancel"}
                      buttonType="danger"
                      onClick={() => setCustom(false)}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="row ">
            <div className="mt-2">
              <div>
                <table className="table table-bordered border border-1 manage-product-table">
                  <thead>
                    <tr>
                      <th>Serial Id</th>
                      <th>LOB Name</th>
                      <th>Category Name</th>
                      <th>Product Name</th>
                      <th>Product Key Features</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allVendorItems &&
                      allVendorItems.length > 0 &&
                      allVendorItems.map((item, index) => {
                        return (
                          <>
                            <tr>
                              <td>{item.id} </td>
                              <td>{item.lob_name} </td>
                              <td>{item.category_name} </td>

                              <td>
                                {!custom ? (
                                  <td>{item.product_name}</td>
                                ) : isDropdownVisible && id === item?.id ? (
                                  <div className="form-group">
                                    <select
                                      name="product"
                                      id="product"
                                      className="form-select py-2 text_style"
                                      value={item.product_name}
                                      onChange={(e) => {
                                        const selectedProduct =
                                          allProducts?.find(
                                            (item) =>
                                              item.name == e.target.value
                                          );
                                        setAllVendorItem((prev) => {
                                          const clone = [...prev];
                                          const itemId = item.id;

                                          clone.forEach((product) => {
                                            if (product.id === itemId) {
                                              product.product_id =
                                                selectedProduct?.id;
                                              product.product_name =
                                                e.target.value;
                                              product.is_updated = true;
                                            }
                                          });
                                          return clone;
                                        });
                                        setIsSubmitShow(true);
                                      }}
                                      onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                          const findItem =
                                            allVendorItems?.filter(
                                              (_, idx) => index === idx
                                            );
                                          handleEnterPress(findItem);
                                        }
                                      }}
                                    >
                                      {allProducts?.length > 0 &&
                                        allProducts?.map((item, index) => (
                                          <>
                                            <option
                                              key={index}
                                              value={item?.name}
                                            >
                                              {item?.name}
                                            </option>
                                          </>
                                        ))}
                                    </select>
                                  </div>
                                ) : (
                                  <p className="ms-1">
                                    <tr>
                                      <a
                                        href="#"
                                        className="link-danger"
                                        onClick={() => {
                                          setIsDropdownVisible(true);
                                          setId(item?.id);
                                          getAllProductsByCategory(
                                            item?.category_id
                                          );
                                          // setErrors("");
                                        }}
                                      >
                                        {item.product_name}
                                      </a>
                                    </tr>
                                  </p>
                                )}
                              </td>

                              {!custom ? (
                                <>
                                  <td>{item.key_feature}</td>
                                </>
                              ) : (
                                <td>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={item?.key_feature}
                                    onChange={(e) => {
                                      setAllVendorItem((prev) => {
                                        const clone = [...prev];
                                        clone[index]["key_feature"] =
                                          e.target.value;
                                        clone[index]["is_updated"] = true;
                                        return clone;
                                      });
                                      setIsSubmitShow(true);
                                      setErrors("");
                                    }}
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter") {
                                        const findItem = allVendorItems?.filter(
                                          (_, idx) => index === idx
                                        );
                                        handleEnterPress(findItem);
                                      }
                                    }}
                                  />

                                  {errors[item.id]?.keyFeatures && (
                                    <span className="text-danger">
                                      {errors[item.id].keyFeatures}
                                    </span>
                                  )}
                                </td>
                              )}
                              <td>
                                {item?.is_active ? (
                                  <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() =>
                                      handleDeleteKeyFeatures(item)
                                    }
                                  >
                                    Deactivate
                                  </button>
                                ) : (
                                  <button
                                    className="btn btn-danger  btn-sm"
                                    onClick={() => activateKeyFeatures(item)}
                                  >
                                    Activate
                                  </button>
                                )}
                              </td>
                            </tr>
                          </>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {showModal.state && (
            <FUSModal
              title={
                showModal.type === "VENDOR_APPROVAL"
                  ? ""
                  : action === "addProduct"
                    ? "Add Product"
                    : action === "addCategory"
                      ? "Add Category"
                      : action === "addItem"
                        ? "Add Item"
                        : "Add Product"
              }
              showModal={showModal.state}
              size={"md"}
              handleClose={() =>
                setShowModal((prev) => ({ ...prev, state: false }))
              }
              centered
            >
              {showModal.type === "VENDOR_APPROVAL" && (
                <h5>
                  Currently your profile is in under validation process .We will
                  notify you once it approved after that only you can access
                  this functionality.
                </h5>
              )}

              {showModal.type === "ADD_PRODUCT" && (
                <>
                  <AddProductItem
                    actionType={(val) => handleActionType(val)}
                    handleClose={(val) => handleClose(val)}
                    setFlag={setFlag}
                    ProductType={"ProductKeyFeatures"}
                  />
                </>
              )}
            </FUSModal>
          )}
        </div>
      </LayoutContainer>
    </>
  );
};

export default Products;
